import { CTASectionLayout } from "..";

export const getLayoutMap = (layout: CTASectionLayout) =>
  layout === "product" ? "blog" : layout;
